import { render, staticRenderFns } from "./PromotionCompletionDermo.vue?vue&type=template&id=a49520ec&"
import script from "./PromotionCompletionDermo.vue?vue&type=script&lang=js&"
export * from "./PromotionCompletionDermo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports